import React, { Component, Fragment } from 'react';

// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';

// Material components
import Drawer from '@material-ui/core/Drawer';

// Custom components
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Footer from './components/Footer';

// Component styles
import styles from './styles';
import { getSidebarOptions, saveSidebarOptions } from '../../utils/local-storage/sidebar-options';

import {AtChatbot} from './components/Chatbot/AtChatbot'

class DashboardLayout extends Component {
    constructor(props) {
        super(props);
        const savedCollapsedStatus = getSidebarOptions()
        const collapsed = savedCollapsedStatus.collapsed;
        const isOpen = savedCollapsedStatus.isOpen;

        this.state = {
            isFirstTime: this.props.isFirstTime,
            checkedA:sessionStorage.getItem('extend_view'),
            collapsed,
            isOpen,
        };
    }

    handleClose = () => {
        this.setState({ isOpen: false });
    };

    handleToggleOpen = () => {
        const { isOpen } = this.state
        this.setState({
            isOpen: !isOpen
        });
        saveSidebarOptions({
            isOpen: !isOpen,
        });
    };

    HandleExpand = (e) => {
        this.setState({
            notificationsEl: null
        });
    };
    handleCollapsedChange = event => {
        const { collapsed } = this.state
        this.setState({
            collapsed: !collapsed ,
        })
        saveSidebarOptions({
            collapsed: !collapsed,
        })
        if (!collapsed) {
            saveSidebarOptions({
                openCollapse: false,
                openCollapseBoard: false,
                openCollapseMonitor: false,
                openCollapseDashboards: false,
            });
        }
    };
    

    render() {
        const { classes, width, title, subtitle, children, callbackFromParent ,checkedA } = this.props;
        const { isOpen, isFirstTime, collapsed } = this.state;
        sessionStorage.setItem("openSide", isOpen)
        const isMobile = ['xs', 'sm'].includes(width);
        const shiftTopbar = isOpen && !isMobile;
        const shiftContent = isOpen && !isMobile;
        return (
            <Fragment>
                <Topbar
                    className={classNames(classes.topbar, {[classes.modalIsOpen]: !isOpen}, {[classes.topbarShift]: shiftTopbar}, {[classes.topbarShiftCollapsed]: collapsed})}
                    isSidebarOpen={isOpen}
                    onToggleSidebar={this.handleToggleOpen}
                    onHandleExpand={this.HandleExpand}
                    title={title}
                    subtitle={subtitle}
                />
                <Drawer
                    anchor="left"
                    classes={{ paper: collapsed ? classes.drawerPaperCollapsed : classes.drawerPaper}}
                    onClose={this.handleClose}
                    open={isOpen}
                    variant={isMobile ? 'temporary' : 'persistent'}
                >

                        <Sidebar 
                            className={[classNames(classes.sidebar ),classNames(classes.customScrollBar)]} 
                            callbackFromParent={callbackFromParent} 
                            isFirstTime={isFirstTime}
                            collapsed={collapsed}
                            handleCollapsedChange={this.handleCollapsedChange}
                        />



                </Drawer>
                <main style={{minHeight: 'calc(100vh - 100px)', marginTop: '100px', backgroundColor: '#ECECEC', display: 'flex', flexDirection: 'column'}} className={classNames(classes.content, {[classes.modalIsOpen]: !isOpen}, {[classes.contentShift]: shiftContent}, {[classes.contentShiftCollapsed]: collapsed})}>
                    <div style={{ flex: 1 }}>
                        {children}
                    </div>
                    <Footer />
                </main>
                <AtChatbot />
            </Fragment>
        );
    }
}

DashboardLayout.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    title: PropTypes.string,
    width: PropTypes.string.isRequired
};

export default compose(
    withStyles(styles),
    withWidth()
)(DashboardLayout);